<template>
    <button class="custom-button" :class="{ disabled: is_disabled }" @click="handleClick">{{ text }}</button>
</template>

<script src="./customButton.js"></script>
<style src="./customButton.scss" lang="scss"></style>
